// visits/VisitsToolbar.jsx
import { Button, Dropdown, Form } from "react-bootstrap";
import { faChevronDown, faFilter, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";

export default function VisitsToolbar({
  q,
  setQ,
  period,
  setPeriod,
  groupMode,
  setGroupMode,
  sortMode,
  setSortMode,
  count,
  searchInputRef,
}) {
  // foco no abrir
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        searchInputRef.current?.focus();
      } catch {}
    }, 250);
    return () => clearTimeout(t);
  }, [searchInputRef]);

  return (
    <div className="hc-cd-toolbar">
      <div className="hc-cd-search">
        <FontAwesomeIcon icon={faMagnifyingGlass} className="hc-cd-search__icon" />
        <Form.Control
          ref={searchInputRef}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar serviço, profissional, observação..."
          aria-label="Buscar no histórico"
        />
      </div>

      <div className="hc-cd-toolbarRight">
        <Dropdown align="end">
          <Dropdown.Toggle className="hc-cd-filterBtn" size="sm" variant="outline-dark">
            <FontAwesomeIcon icon={faFilter} className="me-2" />
            Filtros
            <FontAwesomeIcon icon={faChevronDown} className="ms-2" />
          </Dropdown.Toggle>

          <Dropdown.Menu className="hc-cd-filterMenu">
            <div className="px-3 py-2">
              <div className="hc-cd-filterTitle">Período</div>
              <div className="d-flex flex-wrap gap-2">
                {[
                  { k: "ALL", t: "Tudo" },
                  { k: "30D", t: "30 dias" },
                  { k: "90D", t: "90 dias" },
                  { k: "12M", t: "12 meses" },
                ].map((opt) => (
                  <Button
                    key={opt.k}
                    size="sm"
                    variant={period === opt.k ? "dark" : "outline-dark"}
                    onClick={() => setPeriod(opt.k)}
                  >
                    {opt.t}
                  </Button>
                ))}
              </div>

              <hr className="my-3" />

              <div className="hc-cd-filterTitle">Agrupar</div>
              <div className="d-flex flex-wrap gap-2">
                {[
                  { k: "MONTH", t: "Por mês" },
                  { k: "NONE", t: "Sem agrupar" },
                ].map((opt) => (
                  <Button
                    key={opt.k}
                    size="sm"
                    variant={groupMode === opt.k ? "dark" : "outline-dark"}
                    onClick={() => setGroupMode(opt.k)}
                  >
                    {opt.t}
                  </Button>
                ))}
              </div>

              <hr className="my-3" />

              <div className="hc-cd-filterTitle">Ordenar</div>
              <Form.Select size="sm" value={sortMode} onChange={(e) => setSortMode(e.target.value)}>
                <option value="DATE_DESC">Mais recentes</option>
                <option value="DATE_ASC">Mais antigas</option>
                <option value="VALUE_DESC">Maior valor</option>
                <option value="VALUE_ASC">Menor valor</option>
              </Form.Select>
            </div>
          </Dropdown.Menu>
        </Dropdown>

        <div className="hc-cd-count">{count} registro(s)</div>
      </div>
    </div>
  );
}
